export default __webpack_public_path__ + "static/media/timeline-three.bc0d4ed9.png";